import React, { useEffect, useState } from 'react';
import { EventTypeInput } from '../../../types/ViewModel/EventTypeInput';
import { DateWrapper } from './DateInput.styles';
import eventInputUtils from '../../../utils/event/eventInputUtils';
import EventDatetimeInput from '../event-datetime-input/EventDatetimeInput';
import { InputFieldWrapper, InputHeadingWrapper, InputWrapper } from '../EventInput.styles';
import { resolveHeading } from '../../../utils/event/headingOverrides';

type Props = {
    onChange: (ev: Date | null, key: number, isEmpty: boolean, isValid: boolean) => void;
    evTypeInput: EventTypeInput;
    key: string;
};

const DateInputComponent: React.FC<Props> = (props) => {
    const [, setIsValid] = useState<boolean>(false);
    const [dateTimeValue, setDateTimeValue] = useState<Date | null>(null);
    const { isDateTimeInputValid } = eventInputUtils();

    useEffect(() => {
        if (props.evTypeInput.eventTypeInputReg) {
            setDateTimeValue(props.evTypeInput.eventTypeInputReg.datetimeValueReg);
        }
    }, [props.evTypeInput]);

    const inputHandler = (datetime: Date) => {
        setDateTimeValue(datetime);
        const valid = isDateTimeInputValid(props.evTypeInput, datetime);
        setIsValid(valid);
        props.onChange(datetime, props.evTypeInput.eventTypeInputId, false, valid);
    };

    return (
        <>
            <InputWrapper>
                <InputHeadingWrapper>{resolveHeading(props.evTypeInput)}:</InputHeadingWrapper>
                <InputFieldWrapper>
                    <DateWrapper>
                        <EventDatetimeInput onChange={inputHandler} initialValue={dateTimeValue} key="event_date" />
                    </DateWrapper>
                </InputFieldWrapper>
            </InputWrapper>
        </>
    );
};

export default DateInputComponent;
